<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.75 6A5.75 5.75 0 1 1 6 .25 5.757 5.757 0 0 1 11.75 6zM5.587 8.65a.5.5 0 0 0 .338-.2l3.35-4.543a.5.5 0 1 0-.806-.593L5.43 7.439 3.445 5.85a.5.5 0 1 0-.624.782l2.391 1.912a.5.5 0 0 0 .375.106z"
        />
    </svg>
</template>
